module.exports = __webpack_public_path__ + "static/homer168-7be51db724e9304199de514637299831.jpg";